import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { IViewLog } from '../external-entity.interface';

@Component({
    selector: 'app-view-log',
    templateUrl: './view-log.component.html',
    styleUrls: ['./view-log.component.less'],
    standalone: false
})
export class ViewLogComponent implements OnInit {

  constructor(private formBuilder:FormBuilder) { }

  viewLogList:FormGroup;
  viewLogListDataSource=new MatTableDataSource<IViewLog>();
  viewColumns=['id','name','status','triggerStatus','date','time'];

  ngOnInit(): void {
    this.initializeForm();
  }

  initializeForm(){
    this.viewLogList=this.formBuilder.group({

    });
  }

  sortData(event:any){
    // this.criteria.sort=[event.active,event.direction];
  }
}
